<template>
  <section class="tutor-data">
    <form @submit.prevent="atualizarDadosPaciente" class="form-template">
      <div class="columns">
        <div class="column">
          <b-field label="Nome completo">
            <b-input
              v-model.lazy="data.NomeResponsavel"
              :placeholder="commonPlaceholder"
              disabled
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="CPF">
            <b-input
              :placeholder="commonPlaceholder"
              v-model.lazy="data.CPFResponsavel"
              v-mask="['###.###.###-##']"
              disabled
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="RG">
            <b-input
              v-model="data.RGResponsavel"
              :placeholder="commonPlaceholder"
              v-mask="['##.###.###-#']"
              disabled
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Parentesco">
            <b-input
              v-model="data.ParentescoResponsavel"
              :placeholder="commonPlaceholder"
              disabled
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Sexo">
            <b-input
              v-model="gender"
              :placeholder="commonPlaceholder"
              disabled
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Escolaridade">
            <b-input
              v-model="data.EscolaridadeResponsavel"
              :placeholder="commonPlaceholder"
              disabled
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Ocupação">
            <b-input
              v-model="data.OcupacaoResponsavel"
              :placeholder="commonPlaceholder"
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4 is-offset-8">
          <div class="field">
            <button
              :disabled="!disabledButton"
              class="button button-primary"
              type="submit"
            >
              {{ $t("password_reset.update_button") }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      disabledButton: false,
      commonPlaceholder: this.$t('placeholders.common'),
      dropdown: this.$t('placeholders.dropdown'),
      tutorFullName: 'Maria da Silva Amorim',
      CPF: '123.456.789-10',
      tutorRg: '13221448',
      state: 'DF',
      kinship: 'Mãe',
      employment: ''
    }
  },

  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    ...mapActions(['atualizarPaciente']),
    atualizarDadosPaciente () {
      this.atualizarPaciente()
      this.disabledButton = false
    },
    isReady () {
      this.disabledButton = true
    }
  },

  computed: {
    gender () {
      return this.data.Sexo === 1 ? 'Feminino' : 'Masculino'
    }
  },

  created () {
    this.$store.dispatch('setUFS')
  }

}
</script>

<style lang="scss" scoped>
  @import "~@/assets/stylesheets/base";
  .tutor-data{
    padding-right: 5.3125rem;
    padding-left: 5.3125rem;
  }
  @media (max-width: 64rem) {
    .tutor-data{
      padding-right: 0;
      padding-left: 0;
    }
  }

</style>
